import styled, { css } from 'styled-components';

export const ControlButtonWrapper = styled.div`
	background: #fff;
	border-radius: 4px;
	color: #43575d;
	&:not(:empty) {
		box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
	}
`;

export const Button = styled.button<{ $active: boolean }>`
	background-color: transparent;
	border: 0;
	box-sizing: border-box;
	color: inherit;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 36px;
	outline: none;
	overflow: hidden;
	padding: 0;
	width: 36px;
	${({ $active }) =>
		$active &&
		css`
			color: #00abd1;
		`}
	svg {
		font-size: 20px;
	}
`;
